import { render, staticRenderFns } from "./ModalMask.vue?vue&type=template&id=b6456c5c"
import script from "./ModalMask.vue?vue&type=script&lang=js"
export * from "./ModalMask.vue?vue&type=script&lang=js"
import style0 from "./ModalMask.vue?vue&type=style&index=0&id=b6456c5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports